import React from "react";
import { Auth0ProviderWithHistory } from "./auth/auth0Config";
import { ThemeProvider } from "./contexts/ThemeContext";
import { VideoProvider } from "./contexts/VideoContext";
import { Header } from "./components/Header";
import { VideoGenerator } from "./components/VideoGenerator";
import { VideoPlayer } from "./components/VideoPlayer";
import { CommentSection } from "./components/CommentSection";
import { Chat } from "./components/Chat";
import { useAuth0 } from "@auth0/auth0-react";
import { useVideo } from "./contexts/VideoContext";
import "./App.css";

const MainContent: React.FC = () => {
  const { isLoading, isAuthenticated } = useAuth0();
  const { videos, currentVideo, setCurrentVideo } = useVideo();

  if (isLoading) {
    return <div className="loading">Ładowanie...</div>;
  }

  if (!isAuthenticated) {
    return (
      <div className="welcome-screen">
        <div className="welcome-content">
          <h1>🎬 Witaj w AITube</h1>
          <p>Pierwsza platforma społecznościowa dla AI-generowanych filmów</p>
          <div className="features">
            <div className="feature">🎵 Generuj muzykę AI</div>
            <div className="feature">🎬 Twórz teledyski</div>
            <div className="feature">🗣️ Nagrywaj własny głos</div>
            <div className="feature">💬 Społeczność i komentarze</div>
            <div className="feature">🎨 Filtry i motywy</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-layout">
      <div className="content-area">
        <div className="generator-section">
          <VideoGenerator />
        </div>

        {currentVideo && (
          <div className="video-section">
            <VideoPlayer video={currentVideo} />
            <CommentSection videoId={currentVideo.id} />
          </div>
        )}

        <div className="video-grid">
          <h2>Najnowsze AI Videos</h2>
          <div className="videos">
            {videos.map(video => (
              <div 
                key={video.id} 
                className="video-card"
                onClick={() => setCurrentVideo(video)}
              >
                <img src={video.thumbnail} alt={video.title} />
                <div className="video-card-info">
                  <h3>{video.title}</h3>
                  <p>{video.artist}</p>
                  <div className="video-stats">
                    <span>{video.views} wyświetleń</span>
                    <span>{video.likes} polubień</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Chat />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Auth0ProviderWithHistory>
      <ThemeProvider>
        <VideoProvider>
          <div className="app">
            <Header />
            <MainContent />
          </div>
        </VideoProvider>
      </ThemeProvider>
    </Auth0ProviderWithHistory>
  );
};
export default App;
